(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-hsn-root]').forEach((root) => {
      if (root.dataset.hsnReady) return;
      root.dataset.hsnReady = 'true';
      root.querySelectorAll('[data-hsn-controls]').forEach((item) => { item.hidden = false; });
      const slot = root.querySelector('[data-hsn-slot]');
      const controls = slot?.querySelector('.hss-network-controls');
      if (controls) {
        let frame = 0;
        const positionControls = () => {
          frame = 0;
          if (!root.isConnected) return;
          if (!window.matchMedia('(max-width: 700px)').matches) {
            controls.classList.remove('is-pinned');
            slot.style.removeProperty('height');
            return;
          }
          const bounds = slot.getBoundingClientRect();
          const end = root.getBoundingClientRect().bottom;
          let top = 8;
          document.querySelectorAll('.lsh-header, #StickyNav, .hs-subnav').forEach((bar) => {
            const style = getComputedStyle(bar);
            const rect = bar.getBoundingClientRect();
            if ((style.position === 'fixed' || style.position === 'sticky') && rect.top <= top && rect.bottom > top) top = rect.bottom + 8;
          });
          controls.style.setProperty('--hss-control-left', bounds.left + 'px');
          controls.style.setProperty('--hss-control-width', bounds.width + 'px');
          controls.style.setProperty('--hss-control-top', Math.min(top, end - controls.offsetHeight - 8) + 'px');
          slot.style.height = controls.offsetHeight + 'px';
          controls.classList.toggle('is-pinned', bounds.top < top && end > 0);
        };
        const schedule = () => { if (!frame) frame = requestAnimationFrame(positionControls); };
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule, { passive: true });
        positionControls();
        document.addEventListener('shopify:section:unload', (event) => {
          if (!event.target.contains(root)) return;
          window.removeEventListener('scroll', schedule);
          window.removeEventListener('resize', schedule);
          cancelAnimationFrame(frame);
        });
      }
      const result = root.querySelector('[data-hsn-result]');
      const update = () => {
        const state = root.dataset.state;
        root.querySelectorAll('[data-hsn-state]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.hsnState === state)));
        root.querySelectorAll('[data-hsn-copy]').forEach((copy) => { copy.hidden = copy.dataset.hsnCopy !== state; });
        root.querySelector('[data-hsn-switch]').setAttribute('aria-pressed', String(root.dataset.light === 'on'));
        result.textContent = result.getAttribute(`data-${state}-${root.dataset.light}`);
      };
      root.querySelectorAll('[data-hsn-state]').forEach((button) => button.addEventListener('click', () => { root.dataset.state = button.dataset.hsnState; root.dataset.light = 'off'; update(); }));
      root.querySelector('[data-hsn-switch]').addEventListener('click', () => { root.dataset.light = root.dataset.light === 'on' ? 'off' : 'on'; update(); });
      update();
    });
    scope.querySelectorAll('[data-hsa-root]').forEach((root) => {
      if (root.dataset.hsaReady) return;
      root.dataset.hsaReady = 'true';
      root.querySelector('[data-hsa-controls]').hidden = false;
      root.querySelectorAll('[data-hsa-pick]').forEach((button) => button.addEventListener('click', () => {
        root.querySelectorAll('[data-hsa-pick]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        root.querySelectorAll('[data-hsa-example]').forEach((example) => { example.hidden = example.dataset.hsaExample !== button.dataset.hsaPick; });
      }));
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
